import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const scheduleMessageApi = createApi({
    reducerPath: 'scheduleMessageApi',
    baseQuery: fetchBaseQuery({
        baseUrl: process.env.REACT_APP_API_URL,
        credentials: 'include'
    }),
    endpoints: (builder) => ({
        getScheduleMessageCount: builder.mutation({
            query: (payload) => ({
                url: "messages/scheduled-count",
                method: 'POST',
                body: payload
            })
        }),
        scheduleMessageList: builder.mutation({
            query: (payload) => ({
                url: `messages/scheduled/${payload.userId}`,
                method: 'GET'
            })
        }),
        updateScheduleMessage: builder.mutation({
            query: (payload) => ({
                url: '/messages/scheduled',
                method: 'PATCH',
                body: payload
            })
        }),
        deleteScheduleMessage: builder.mutation({
            query: (payload) => ({
                url: `/messages/scheduled/${payload.id}`,
                method: 'DELETE',
                body: payload
            })
        }),
        sendScheduleMessage: builder.mutation({
            query: (payload) => ({
                url: '/messages/scheduled-send',
                method: 'POST',
                body: payload
            })
        })
    })
})

export const {
    useGetScheduleMessageCountMutation,
    useScheduleMessageListMutation,
    useUpdateScheduleMessageMutation,
    useDeleteScheduleMessageMutation,
    useSendScheduleMessageMutation
} = scheduleMessageApi;
